import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormState } from 'react-final-form';

import { advanceOnboardingStateAction, backOnboardingStateAction } from 'Shared/actions/onboardingState';

import { OnboardingWizardStep } from '../../../../types';

import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpButton, WpButtonGroup } from 'Wpds/components/button';

type Props = {
  errorsDisableSubmit?: Function;
};

function OnboardingWizardButtonsArea({ errorsDisableSubmit }: Props) {
  const dispatch = useDispatch();
  const step: OnboardingWizardStep = useSelector(state => state.onboardingState.step);
  const showFinishButton = useSelector(state => state.onboardingState.showFinishButton);

  const handleSkipClick = useCallback(() => dispatch(advanceOnboardingStateAction({ didSkip: true })), [dispatch]);

  const handleBackClick = useCallback(() => dispatch(backOnboardingStateAction()), [dispatch]);

  const { submitting, errors } = useFormState();
  const errorsExist = errorsDisableSubmit
    ? errorsDisableSubmit(errors)
    : !!Object.keys(errors).filter(key => errors[key]).length;

  return (
    <div className="d-flex onboarding-buttons-area pt-2">
      <WpButtonGroup>
        {![
          OnboardingWizardStep.profile,
          OnboardingWizardStep.zoomProfileAndWorkspaces,
          OnboardingWizardStep.zoomProfile,
          OnboardingWizardStep.workspaces,
          OnboardingWizardStep.workspacesFromCalendar,
        ].includes(step) ? (
          <WpButton size="lg" variant="tertiary" disabled={submitting} onClick={handleSkipClick}>
            Skip
          </WpButton>
        ) : null}
        {step === OnboardingWizardStep.profile ? null : (
          <WpButton size="lg" variant="secondary" disabled={submitting} onClick={handleBackClick}>
            <WpIcon name="long-arrow-left" />
            Back
          </WpButton>
        )}
        <WpButton size="lg" btnType="submit" disabled={errorsExist} loading={submitting}>
          {showFinishButton ? 'Finish' : 'Next'}
          {!showFinishButton && <WpIcon name="long-arrow-right" />}
        </WpButton>
      </WpButtonGroup>
    </div>
  );
}

export default OnboardingWizardButtonsArea;
